import { DatePipe } from '@angular/common';
import {
    Component, HostListener,
    OnDestroy, OnInit,
    TemplateRef,
    ViewChild,
    ViewContainerRef
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BarcodeFormat } from '@zxing/library';
import { saveAs } from 'file-saver';
import { MASKS } from 'ng-brazil';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Subscription } from 'rxjs';
import { Unidade } from 'src/app//models/unidade';
import { AssociarQRCodeRequest } from 'src/app/models/AssociarQRCodeRequest';
import { AssociateCardModel } from 'src/app/models/associate-card-model';
import { Auth } from 'src/app/models/auth';
import { BeneficioColaborador, BeneficioGrupo } from 'src/app/models/beneficio-colaborador';
import { CedenteContrato } from 'src/app/models/cedente-contrato';
import { CentroCusto } from 'src/app/models/centro-custo';
import { Colaborador } from 'src/app/models/colaborador';
import { Collaborator, CollaboratorAccounts } from 'src/app/models/collaborator';
import { CollaboratorFilter } from 'src/app/models/collaborator-filter';
import { CollaboratorType } from 'src/app/models/collaborator-type';
import { CollaboratorDetailsModel } from 'src/app/models/CollaboratorDetailsModel';
import { Departamento } from 'src/app/models/departamento';
import { FiltroColaborador } from 'src/app/models/filtro-colaborador';
import { BlockRequest, UpdateRequest } from 'src/app/models/physical-card';
import { Produto } from 'src/app/models/produto';
import { FastPurchase, Order, OrderItens, Purchase, PurchaseItens } from 'src/app/models/purchase';
import { ExtractConsumerRequest, ExtractRequest } from 'src/app/models/request/extract-request';
import { SuspendColllaboratorRequestModel } from 'src/app/models/request/suspend-collaborator-request';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { CentroCustoService } from 'src/app/services/centro-custo.service';
import { ColaboradorService } from 'src/app/services/colaborador.service';
import { ConductorService } from 'src/app/services/conductor.service';
import { ContratoService } from 'src/app/services/contrato.service';
import { DepartamentoService } from 'src/app/services/departamento.service';
import { ExtractService } from 'src/app/services/extract.service';
import { FiltroColaboradorService } from 'src/app/services/filtro-colaborador.service';
import { GestorService } from 'src/app/services/gestor.service';
import { ParametrosDataService } from 'src/app/services/parametros-data.service';
import { PedidoService } from 'src/app/services/pedido.service';
import { PerfilService } from 'src/app/services/perfil.service';
import { PhysicalCardService } from 'src/app/services/physical-card.service';
import { SaldoCedenteService } from 'src/app/services/saldo-cedente.service';
import { SecurityService } from 'src/app/services/security.service';
import { UnidadeService } from 'src/app/services/unidade.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { ParametrosKey } from 'src/app/shared/enums/parametros.enum';
import { PerfilNormalizado } from 'src/app/shared/enums/perfil-normalizado.enum';
import { StatusColaborador } from 'src/app/shared/enums/status-colaborador.enum';
import { BooleanConverter } from 'src/app/shared/helpers/converters/boolean-converter';
import { ColaboradorFilterOptions } from 'src/app/shared/helpers/models/colaborador-filter-options';
import { DropDownItem } from 'src/app/shared/helpers/models/dropdown-item';
import { ExcelService, WorksheetData } from 'src/app/shared/services/excel.service';
import { PdfData, PdfService } from 'src/app/shared/services/pdf.service';
import { GenericValidator } from 'src/app/shared/validators/generic-validator.validator';
import { environment } from 'src/environments/environment';


@Component({
    selector: 'app-colaborador-list',
    templateUrl: './colaborador-list.component.html',
    styleUrls: ['./colaborador-list.component.css']
})
export class ColaboradorListComponent implements OnInit, OnDestroy {
    public currentUser: Auth;
    public colaboradores: Colaborador[] = [];
    public collaborators: Collaborator[] = [];
    public colaboradoresList: Colaborador[] = [];
    public collaboratorsList: Collaborator[] = [];
    public Status = StatusColaborador;
    public centrosCustosList: CentroCusto[];
    public unidadesList: Unidade[];
    public departamentosList: Departamento[];
    public produtosList: CedenteContrato[];
    public produto: Produto;
    public filtroOn: boolean = false;
    public filtroCodigo = '';
    public filtroNome = '';
    public filtroCPF = '';
    public filtroMatricula = '';
    public filtroCentroCusto: string;
    public filtroUnidade: string;
    public filtroDepartamento: string;
    public filtroAplicativo = '';
    public filtroPesquisa = '';
    public filtroType: number;
    public filtroSituacao: string = null;
    public collaboratorToDisable: Collaborator;
    public collaboratorToEnable: Collaborator;
    public collaboratorSelected: Collaborator;
    public deleteCount: number;
    public selectAll: boolean;
    public CollaboratorDetailsModel: CollaboratorDetailsModel;
    public step = 0;
    public cedenteContrato: CedenteContrato;
    public colaboradorToCode: Collaborator;
    public colaboradorToAlterPass: Collaborator;
    public messageStepOk: boolean;
    public messageStep: string;
    public inQRCodeInvalid = false;
    public inSenhaInvalid = false;
    public inCodigoInvalid = false;
    public inValorInvalid = false;
    public showBenefits = false;
    public messageSenha: string;
    public messageCodigo: string;
    public isValidToAddQRCode: boolean;
    public loaded = false;
    public messageStatus: string;
    public messageValor: string;
    public exibirFiltro = true;
    public isMobile = false;
    public showScanner = false;
    private id: number;
    private routeSubscription: Subscription;
    public valorBeneficio: number;
    public MASKS = MASKS;
    public beneficios: BeneficioColaborador[] = [];
    public beneficioGrupo: BeneficioGrupo[] = [];

    public cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];

    sortOrder: boolean = false;
    // overlayRef: OverlayRef | null;
    subscription: Subscription;

    // páginação
    currentPage = 1;
    showItem = '10';
    totalItems = 0;
    collumnName = "name";

    //#region filtro DropDown
    public filtroCentroCustoDropDownList = [];
    public filtroCentroCustoSelectedItems = [];
    public filtroUnidadeDropDownList = [];
    public filtroUnidadeSelectedItems = [];
    public filtroDepartamentoDropDownList = [];
    public filtroDepartamentoSelectedItems = [];
    public filtroProdutosDropDownList = [];
    public filtroProdutosSelectedItems = [];

    public dropDownSettings: IDropdownSettings = {};

    public costCenterCtrl: FormControl = new FormControl();
    public unitCtrl: FormControl = new FormControl();
    public departmentCtrl: FormControl = new FormControl();
    public productCtrl: FormControl = new FormControl();
    public typeCtrl: FormControl = new FormControl();
    public appCtrl: FormControl = new FormControl();
    public situationCtrl: FormControl = new FormControl();
    public nameCtrl: FormControl = new FormControl();
    public cpfCtrl: FormControl = new FormControl();
    public registerCtrl: FormControl = new FormControl();
    ////#endregion

    private parametros: { [key: string]: string };
    public labelMatricula = 'Matrícula';
    public labelCentroCusto = 'Centro de Custo';
    public labelUnidade = 'Unidade';
    public labelDepartamento = 'Departamento';
    public labelProdutos = 'Produtos';
    public labelSituacao = 'Situação';

    public cedenteContratoList: CedenteContrato[];

    public valorRecargaForm: FormGroup;
    public associateCardForm: FormGroup;
    public cardPasswordResetFormGroup: FormGroup;

    public usarSenhaExistente = false;
    public hasProdutos = true;
    public hasBeneficios = true;
    public continuarRecarga = false;
    public selectedProduct: BeneficioColaborador;
    public fastPurchase: FastPurchase;
    public qrcodeValue: string;

    public loadList = true;

    @ViewChild('contextMenu', { static: true }) contextMenu: TemplateRef<any>;
    @ViewChild('novobeneficio', { static: true }) novoBeneficio: TemplateRef<any>;
    @ViewChild('novoColaborador', { static: true })
    novoColaborador: TemplateRef<any>;

    @ViewChild('novoColaboradorLote', { static: true })
    novoColaboradorLote: TemplateRef<any>;


    @ViewChild('modalAvisoVincularCartao', { static: true })
    modalAvisoVincularCartao: TemplateRef<any>;

    //@ViewChild('inQRCode', {static: false}) inQRCode: ElementRef;
    //@ViewChild('inValor', {static: false}) inValor: ElementRef;

    //#region qr-code
    availableDevices: MediaDeviceInfo[];
    currentDevice: MediaDeviceInfo = null;

    formatsEnabled: BarcodeFormat[] = [BarcodeFormat.QR_CODE];

    hasDevices: boolean;
    hasPermission: boolean;

    qrResultString = '';

    public isGestao: boolean = false;

    tryHarder = false;

    qrCodeDetected = false;
    qrCodeDetectedVisivle = false;
    permitirVincularQRCode = false;
    permitirAdicionarColaboradorEmLotes = false;
    permitirVincularQRemLote = false;
    public permitirDesativarColaborador = true;
    permitirCartaoFisico = true;
    //#endregion

    public mostrarDetalhes = false;
    public mostrarColunaAplicativo = true;
    public mostrarColunaCentroCusto = true;
    public mostrarColunaUnidade = true;
    public mostrarColunaDepartamento = true;
    public mostrarColunaStatus = true;
    public temContaSeuValeLog = false;
    public temContaDespesas = false;


    public startDateSuspend: Date;
    public endDateSuspend: Date;
    public justifySuspend: FormControl = new FormControl();

    public permitirGerenciarCartoesBeneficio = true;
    justificativaValid: boolean = true;
    public showReasons = false;

    temp: any;

    //#region Historio Credito
    public extratoPeriodo = 0;
    public extratoProduto: number[] = [];
    public extratoDataFim = new Date();
    public extratoDataInicio = new Date();
    public colaId: Collaborator;
    public extractDetails: any;
    public extractList = [];
    public extracttotalItems: any;
    public extractPage = 1;
    public collaboratorType: CollaboratorType[];

    //#region Extrato Favorecido
    public accounts = new CollaboratorAccounts;
    public limitModal: number = 5;
    public filterObject = new ExtractConsumerRequest();
    isResposavel: any;
    validarPin: boolean;
    pinMensagemErro: any;

    //#region Cartao fisico
    showOtherReasonInp: boolean;
    public reasons: any[] = [
        {
            id: 1,
            value: 'Uma nova via do cartão foi solicitada',
            psBlockCode: 12,
        },
        {
            id: 2,
            value: 'O cartão foi expirado e bloqueado. Uma nova via será enviada',
            psBlockCode: 15,
        },
        {
            id: 3,
            value: 'Cartão dado como extraviado pelo seu usuário ou titular',
            psBlockCode: 22,
        },
        {
            id: 4,
            value: 'Cartão bloqueado por motivo de perda alegada pelo titular',
            psBlockCode: 35,
        }
    ];
    private reason: any;

    constructor(
        private colaboradorService: ColaboradorService,
        private centroCustoService: CentroCustoService,
        private unidadeService: UnidadeService,
        private departamentoService: DepartamentoService,
        private authenticationService: AuthenticationService,
        private alertService: NewAlertService,
        private modalService: NgbModal,
        private router: Router,
        private route: ActivatedRoute,
        private fb: FormBuilder,
        // public overlay: Overlay,
        public viewContainerRef: ViewContainerRef,
        private contratoService: ContratoService,
        private securityService: SecurityService,
        private parametrosDataService: ParametrosDataService,
        private perfilService: PerfilService,
        private gestorService: GestorService,
        private filterService: FiltroColaboradorService,
        private saldoCedenteService: SaldoCedenteService,
        private pedidoService: PedidoService,
        private extractService: ExtractService,
        public datepipe: DatePipe,
        public conductorService: ConductorService,        
        private physicalCardService: PhysicalCardService,
    ) {
        this.onResize();
    }

    @HostListener('window:resize', ['$event'])
    onResize(event?) {
        this.isMobile = window.innerWidth <= 500;
    }


    @ViewChild('modalVerCartao', { static: true })
    modalVerCartao: TemplateRef<any>;

    ngOnInit() {
        this.currentUser = this.authenticationService.currentUserValue;
        this.getFilter();

        this.isResposavel = this.perfilService.currentPerfisValue.some(x => x.nomeNormalizado === PerfilNormalizado.Responsavel);
        this.validarPin = BooleanConverter.getBoolean(
            this.parametrosDataService.currentParametrosValue[ParametrosKey.validarPinDestinacaoCredito]
        );

      /*  this.modalService.open(this.modalVerCartao, {
            centered: true,
            size: 'lg'
        });*/

        this.loadFiltroDropDown();
        //this.LoadValorPadrao();
        this.createForm();
        this.loadViewConfig();
        this.loadBeneficios();

        if(this.router.url == '/portal/gestao-beneficio/list'){
            this.isGestao = true;
        }

        if(sessionStorage.getItem('currentPageB') != null){
            this.currentPage = parseInt(sessionStorage.getItem('currentPageB'));
            sessionStorage.removeItem('currentPageB');
            sessionStorage.removeItem('currentCollaborator');
            this.pageChangedGateway(this.currentPage);
            this.loadList = false;
        }

        this.routeSubscription = this.route.paramMap.subscribe(params => {
            this.id = +params.get('id');

            if (this.id > 0) {
                this.filtroPesquisa = this.id.toString();
                this.pageChangedGateway(1);
                this.loadList = false;
            }

            if (this.loadList) {
                this.situationCtrl.setValue("1");
                this.applyFilter()
                // this.pageChangedGateway(1);
            }
        });

        this.collaboratorType = JSON.parse(localStorage.getItem('collaboratorType'));

        if (true)
            this.collaboratorType = this.collaboratorType.filter(x => x.collaboratorTypeId != 5)
    }

    ngOnDestroy() {
        this.routeSubscription.unsubscribe();
    }

    private loadBeneficios() {
        this.contratoService.getContractsAssignorProducts(this.currentUser.token.assignorGuid).subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                    // this.cedenteContratoList = response.result;

                    if (response.result.length <= 0) {
                        this.hasProdutos = false;
                    }
                } else {
                    this.alertService.error(response.message);
                }
            },
            error => {
                this.alertService.error('Erro ao carregar os contratos do cedente' + error);
            }
        );
    }

    loadViewConfig() {
        this.parametros = this.parametrosDataService.currentParametrosValue;
        if (this.parametros) {
            if (this.parametros[ParametrosKey.exibirFiltrosColaboradores]) {
                this.exibirFiltro = BooleanConverter.getBoolean(
                    this.parametros[ParametrosKey.exibirFiltrosColaboradores]
                );
            } else {
                this.exibirFiltro = true;
            }

            if (this.parametros[ParametrosKey.temContaSeuValeLog]) {
                this.temContaSeuValeLog = BooleanConverter.getBoolean(this.parametros[ParametrosKey.temContaSeuValeLog]);
            }

            if (this.parametros[ParametrosKey.temContaDespesas]) {
                this.temContaDespesas = BooleanConverter.getBoolean(this.parametros[ParametrosKey.temContaDespesas]);
            }

            if (this.parametros[ParametrosKey.exibirFlagAplicativo] &&
                !BooleanConverter.getBoolean(
                    this.parametros[ParametrosKey.exibirFlagAplicativo]
                )) {
                this.mostrarColunaAplicativo = false;
            }

            if (this.parametros[ParametrosKey.buscarListaColaboradoresInicialmente] &&
                !BooleanConverter.getBoolean(
                    this.parametros[ParametrosKey.buscarListaColaboradoresInicialmente]
                )) {
                this.loadList = false;
            }

            if (this.parametros[ParametrosKey.exibirOpcaoVerDetalhes]) {
                this.mostrarDetalhes = true;
            }

            if (
                this.parametros[
                ParametrosKey.labelPersonalizadaMatriculaColaborador
                ]
            ) {
                this.labelMatricula = this.parametros[
                    ParametrosKey.labelPersonalizadaMatriculaColaborador
                ];
            } else {
                this.labelMatricula = 'Matrícula';
            }

            if (
                this.parametros[
                ParametrosKey.labelPersonalizadaCentroCustoColaborador
                ]
            ) {
                this.labelCentroCusto = this.parametros[
                    ParametrosKey.labelPersonalizadaCentroCustoColaborador
                ];
            } else {
                this.labelCentroCusto = 'Centro de Custo';
            }

            if (
                this.parametros[
                ParametrosKey.labelPersonalizadaUnidadeColaborador
                ]
            ) {
                this.labelUnidade = this.parametros[
                    ParametrosKey.labelPersonalizadaUnidadeColaborador
                ];
            } else {
                this.labelUnidade = 'Unidade';
            }

            if (
                this.parametros[
                ParametrosKey.labelPersonalizadaDepartamentoColaborador
                ]
            ) {
                this.labelDepartamento = this.parametros[
                    ParametrosKey.labelPersonalizadaDepartamentoColaborador
                ];
            } else {
                this.labelDepartamento = 'Departamento';
            }

            if (
                this.parametros[
                ParametrosKey.labelPersonalizadaProdutosColaborador
                ]
            ) {
                this.labelProdutos = this.parametros[
                    ParametrosKey.labelPersonalizadaProdutosColaborador
                ];
            } else {
                this.labelProdutos = 'Produtos';
            }

            if (
                this.parametros[
                ParametrosKey.labelPersonalizadaStatusColaborador
                ]
            ) {
                this.labelSituacao = this.parametros[
                    ParametrosKey.labelPersonalizadaStatusColaborador
                ];
            } else {
                this.labelSituacao = 'Situação';
            }

            if (this.parametros[ParametrosKey.exibirColunaCentroCustoColaboradores] &&
                !BooleanConverter.getBoolean(
                    this.parametros[ParametrosKey.exibirColunaCentroCustoColaboradores]
                )) {
                this.mostrarColunaCentroCusto = false;
            }

            if (this.parametros[ParametrosKey.exibirColunaUnidadeColaboradores] &&
                !BooleanConverter.getBoolean(
                    this.parametros[ParametrosKey.exibirColunaUnidadeColaboradores]
                )) {
                this.mostrarColunaUnidade = false;
            }

            if (this.parametros[ParametrosKey.exibirColunaDepartamentoColaboradores] &&
                !BooleanConverter.getBoolean(
                    this.parametros[ParametrosKey.exibirColunaDepartamentoColaboradores]
                )) {
                this.mostrarColunaDepartamento = false;
            }

            if (this.parametros[ParametrosKey.exibirStatusColaborador] &&
                !BooleanConverter.getBoolean(
                    this.parametros[ParametrosKey.exibirStatusColaborador]
                )) {
                this.mostrarColunaStatus = false;
            }

            if (this.parametros[ParametrosKey.permitirDesativarColaborador]) {
                this.permitirDesativarColaborador = BooleanConverter.getBoolean(
                    this.parametros[ParametrosKey.permitirDesativarColaborador]
                );
            }

            if (this.parametros[ParametrosKey.permitirVincularQRCode]) {
                this.permitirVincularQRCode = BooleanConverter.getBoolean(
                    this.parametros[ParametrosKey.permitirVincularQRCode]
                );
            } else {
                this.permitirVincularQRCode = false;
            }

            if (this.parametros[ParametrosKey.permitirAdicionarColaboradorEmLotes]) {
                this.permitirAdicionarColaboradorEmLotes = BooleanConverter.getBoolean(
                    this.parametros[ParametrosKey.permitirAdicionarColaboradorEmLotes]
                );
            } else {
                this.permitirAdicionarColaboradorEmLotes = false;
            }

            if (this.parametros[ParametrosKey.permitirVincularQRemLote]) {
                this.permitirVincularQRemLote = BooleanConverter.getBoolean(
                    this.parametros[ParametrosKey.permitirVincularQRemLote]
                );
            } else {
                this.permitirVincularQRemLote = false;
            }

            if (this.parametros[ParametrosKey.permitirCartaoFisico] &&
                !BooleanConverter.getBoolean(
                    this.parametros[ParametrosKey.permitirCartaoFisico]
                )) {
                this.permitirCartaoFisico = false;
            }

            // ao criar o colaborador se true redireciona para a página de cartões
            if (this.parametros[ParametrosKey.permitirGerenciarCartoesBeneficio]) {
                this.permitirGerenciarCartoesBeneficio = BooleanConverter.getBoolean(this.parametros[ParametrosKey.permitirGerenciarCartoesBeneficio]);
            }
        }
    }

    pageChangedGateway(event) {
        this.currentPage = event;
        const offset = this.currentPage - 1;

        const filterOptions = new ColaboradorFilterOptions();

        const filterObject = new CollaboratorFilter();

        filterObject.query = this.filtroPesquisa;
        filterObject.name = this.filtroNome;
        filterObject.document = this.filtroCPF;
        filterObject.register = this.filtroMatricula;
        filterObject.orderby = this.collumnName;
        filterObject.ordertype = this.sortOrder;
        filterObject.situation = this.filtroSituacao;
        filterObject.type = this.filtroType;
        filterObject.costCenter = this.filtroCentroCustoSelectedItems.map((i) => Number(i));
        filterObject.unit = this.filtroUnidadeSelectedItems.map((i) => Number(i));
        filterObject.departament = this.filtroDepartamentoSelectedItems.map((i) => Number(i));
        filterObject.products = this.filtroProdutosSelectedItems;

        filterOptions.aplicativo = this.filtroAplicativo;

        // parametros
        if (this.parametros[ParametrosKey.permitirBuscaNomeColaboradores]) {
            filterOptions.permitirBuscarNome = BooleanConverter.getBoolean(
                this.parametros[ParametrosKey.permitirBuscaNomeColaboradores]
            );
        }
        if (this.parametros[ParametrosKey.permitirBuscaCPFColaboradores]) {
            filterOptions.permitirBuscarCPF = BooleanConverter.getBoolean(
                this.parametros[ParametrosKey.permitirBuscaCPFColaboradores]
            );
        }
        if (
            this.parametros[
            ParametrosKey.permitirBuscaNomeIncrementalColaboradores
            ]
        ) {
            filterOptions.permitirBuscarNomeLike = BooleanConverter.getBoolean(
                this.parametros[
                ParametrosKey.permitirBuscaNomeIncrementalColaboradores
                ]
            );
        }
        if (
            this.parametros[
            ParametrosKey.permitirBuscaCPFIncrementalColaboradores
            ]
        ) {
            filterOptions.permitirBuscarCPFLike = BooleanConverter.getBoolean(
                this.parametros[
                ParametrosKey.permitirBuscaCPFIncrementalColaboradores
                ]
            );
        }
        if (this.parametros[ParametrosKey.permitirBuscaVaziaColaboradores]) {
            filterOptions.permitirBuscarVazio = BooleanConverter.getBoolean(
                this.parametros[ParametrosKey.permitirBuscaVaziaColaboradores]
            );
        }

        this.alertService.clear();
        this.colaboradorService
            .getAllPagedGateway(
                this.currentUser.token.assignorGuid,
                offset,
                +this.showItem,
                filterObject,
                filterOptions
            )
            .subscribe(
                response => {

                    if (response.status === ApiError.Sucesso) {
                        this.collaborators = response.result.collaborators;
                        for (const s of this.collaborators) {
                            if(s.document != null){
                                const tam = environment.TOTAL_CARACTERE_CPF - s.document.length;
                                let str = s.document.toString();

                                for (let i = 0; i < tam; i++) {
                                    str = '0' + str;
                                }

                                s.document = str;
                            }

                            if (s.costCenter === null) {
                                s.costCenter = 'Nenhum';
                            }

                            if (s.unit === null) {
                                s.unit = 'Nenhum';
                            }

                            if (s.departament === null) {
                                s.departament = 'Nenhum';
                            }

                            s.situation = this.capitalize(s.situation);
                        }

                        this.collaboratorsList = this.collaborators;
                        this.totalItems = response.result.totalResults;
                    } else {
                        this.alertService.error(response.message);
                    }
                },
                error => {
                    this.alertService.error(
                        'Ocorreu um erro ao paginar favorecidos'
                    );
                }
            );
    }

    confirmarRecarga(content,valorPadrao: number, taxa: number = 0, valorMaximoBeneficio: number, ehPorcentagem: boolean) {
        this.solicitarPin();
        let nvalor;
        let valorTaxa;
        if(this.valorRecargaForm.controls.valorRecarga.value){
            nvalor = this.valorRecargaForm.controls.valorRecarga.value;
            //nvalor = +nvalor.replace('R$', '').replace(/\./g, '').replace(',', '.').trim();
        }
        else{
            nvalor = valorPadrao;
        }

        if(nvalor <= 0 /*|| nvalor > valorMaximoBeneficio || nvalor < valorPadrao*/){
            this.messageValor = 'Insira um valor válido';
            this.inValorInvalid = true;
            return;
        }

        if(taxa > 0){
            if(ehPorcentagem){
                valorTaxa = nvalor * taxa / 100;
                nvalor += nvalor * taxa / 100;
            }
            else{
                valorTaxa = taxa;
                nvalor = nvalor + taxa;
            }
        }


        const purchase = new FastPurchase(
            (Math.round(nvalor * 1000) / 1000), taxa, valorTaxa, this.selectedProduct.produtoId, this.selectedProduct.cedenteContratoId,
            this.selectedProduct.periodoValor, this.selectedProduct.valor, this.selectedProduct.produtoGuid,
            this.selectedProduct.produtoNome, this.selectedProduct.periodo, ehPorcentagem,
            this.selectedProduct.cartaoId
        );

        if(!this.isResposavel && this.validarPin ){
            this.fastPurchase = purchase;
            this.modalService.open(content, { centered: true });
        } else {
            this.createPurchase(purchase);
            this.modalService.dismissAll();
            this.pageChangedGateway(this.currentPage);
        }
    }

    verificarPin(pin){
        this.pinMensagemErro = null;
        pin = +pin
        this.gestorService.confirmarPin(this.currentUser.token.assignorGuid,this.currentUser.token.userReferenceId,pin).subscribe(
            res => {
                if (res.status === ApiError.Sucesso) {
                    this.createPurchase(this.fastPurchase);
                    this.modalService.dismissAll();
                    this.pageChangedGateway(this.currentPage);
                } else {
                    this.pinMensagemErro = res.message;
                }
            }
        );
    }

    createPurchase(item: FastPurchase){

        this.fastPurchase = item;

        const currentDate = new Date()
        const releaseDate = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            currentDate.getDate(),
            currentDate.getHours() - 3,
            currentDate.getMinutes(),
            currentDate.getSeconds()
        );

        const gestorCedente = JSON.parse(sessionStorage.getItem('gestorCedente'));
        let value = Math.round(item.value * 1000) / 1000;
        let purchase = new Purchase(0,'');
        purchase.purchaseItens = [];
        let orderItem = new OrderItens();

        let fee = 0;
        if(item.feeValue > 0 && item.isPercent){
            fee = Math.round(item.feeValue * 1000) / 1000;
        }
        if(item.feeValue > 0 && !item.isPercent){
            fee = item.feeValue;
        }

        purchase.assignorId = parseInt(sessionStorage.getItem('cedenteId'));
        purchase.managerGuid = this.currentUser.token.userReferenceId;
        purchase.purchaseUseBalance = true;
        purchase.purchaseValue = Math.round(value * 1000) / 1000;
        purchase.purchaseToPayValue = Math.round(value * 1000) / 1000;
        purchase.purchaseValuePay = 0;
        purchase.purchaseFee = item.feeValue > 0 ? Math.round(item.feeValue * 1000) / 1000 : 0;
        purchase.purchaseItens[0] = new PurchaseItens();;
        purchase.purchaseItens[0].productId = item.productId;

        purchase.purchaseItens[0].order = new Order();
        purchase.purchaseItens[0].order.orderItens = [];
        purchase.purchaseItens[0].order.managerId = gestorCedente.gestorId;
        purchase.purchaseItens[0].order.assignorContractId = item.assignorContractId;
        purchase.purchaseItens[0].order.productGuid = item.productGuid;
        purchase.purchaseItens[0].order.productDescription = item.productName;
        purchase.purchaseItens[0].order.orderValue = Math.round(value * 1000) / 1000;
        purchase.purchaseItens[0].order.totalFee = fee;
        purchase.purchaseItens[0].order.totalFeePercent = item.fee > 0 ? item.fee : 0;
        purchase.purchaseItens[0].order.releaseDate = releaseDate;

        orderItem.hasApp = this.colaboradorToCode.hasApp;
        orderItem.hasCard = this.colaboradorToCode.hasCard;
        orderItem.regularityId = item.regularityId;
        orderItem.regularityDescription = item.regularityDescription;
        orderItem.referenceValue = item.referenceValue;
        orderItem.providedValue = item.feeValue > 0 ? (value - fee) : value;
        orderItem.name = this.colaboradorToCode.name;
        orderItem.document= this.colaboradorToCode.document;
        orderItem.registry = this.colaboradorToCode.register;
        orderItem.cardId = item.cardId;
        orderItem.collaboratorId = this.colaboradorToCode.collaboratorID;

        purchase.purchaseItens[0].order.orderItens[0] = orderItem;

        this.pedidoService.createPurchase(this.currentUser.token.assignorGuid, purchase).subscribe(
            res => {
                if (res.status === ApiError.Sucesso){

                    purchase.purchaseId = res.result.purchaseId;
                    purchase.paymentMethodId = null;
                    purchase.purchaseItens[0].purchaseId = res.result.purchaseItens[0].purchaseId;
                    purchase.purchaseItens[0].purchaseItemId = res.result.purchaseItens[0].purchaseItemId;
                    purchase.purchaseItens[0].order.orderId = res.result.purchaseItens[0].order.orderId;
                    purchase.purchaseItens[0].order.orderDescription = res.result.purchaseItens[0].order.orderDescription;
                    purchase.purchaseItens[0].order.orderItens[0].orderItemId = res.result.purchaseItens[0].order.orderItens[0].orderItemId;
                    purchase.purchaseItens[0].order.orderItens[0].cardId = res.result.purchaseItens[0].order.orderItens[0].cardId;
                    purchase.purchaseItens[0].order.orderItens[0].regularityId = res.result.purchaseItens[0].order.orderItens[0].regularityId;
                    purchase.purchaseItens[0].order.orderItens[0].regularityDescription = res.result.purchaseItens[0].order.orderItens[0].regularityDescription;

                    this.pedidoService.finishPurchase(this.currentUser.token.assignorGuid, purchase).subscribe(
                        res => {
                            if(res.status === ApiError.Sucesso){
                                this.alertService.success('Solicitação de carregamento do cartão efetuada com sucesso! Aguarde alguns segundos para que o carregamento seja concluído.');
                                this.saldoCedenteService.updateBalance(this.currentUser.token.assignorGuid);
                            } else {
                                this.alertService.error('Não foi possível fazer o carregamento do cartão!');
                            }
                        },
                        error => {
                            console.log(error);
                            this.alertService.error('Não foi possível fazer o carregamento do cartão!');
                        }
                    )
                } else {
                    this.alertService.error('Não foi possível fazer o carregamento do cartão!');
                }
            },
            error => {
                console.log(error);
                this.alertService.error('Não foi possível fazer o carregamento do cartão!');
            }
        )
    }

    showItemChanged(event) {
        this.showItem = event;
        this.pageChangedGateway(1);
    }

    setProdutoCarga(item: BeneficioColaborador) {
        this.selectedProduct = item;
        this.LoadValorPadrao();
    }

    setProdutoRecarga(item: BeneficioColaborador) {
        this.selectedProduct = item;
    }

    LoadValorPadrao() {
        return this.contratoService
            .getValorPadrao(this.currentUser.token.assignorGuid, this.selectedProduct.produtoId)
            .subscribe(response => {

                if(response.status === 1){

                    // qr-code zerado
                    this.qrResultString = '';

                    this.cedenteContrato = response.result;
                    /*if (
                        (!this.cedenteContrato.valorPadrao ||
                        !this.cedenteContrato.valorMaximoBeneficio ||
                        !this.cedenteContrato.valorIncremento ||
                        this.cedenteContrato.valorMaximoBeneficio === 0) &&
                        this.cedenteContrato.ehEditavel /*||
                        this.cedenteContrato.valorIncremento === 0*/
                    /*) {
                        this.isValidToAddQRCode = false;
                        this.messageStatus = 'Você deve ajustar os valores padrões do produto';
                    }*/

                    if(this.step == 0){
                        if(this.selectedProduct != null){
                            this.step = 10;
                            this.isValidToAddQRCode = true;
                        }
                    }
                    this.loaded = true
                }
                else{
                    this.alertService.error(response.message);
                }
            },error=>{
                this.alertService.error('Não foi possível obter os dados do produto');
            });
    }

    navigateToNovoBeneficio() {
        this.router.navigate(['portal/novobeneficio']);
    }

    create() {
        this.contratoService
            .getContractsAssignorProducts(this.currentUser.token.assignorGuid)
            .subscribe(response => {
                if (response.status === ApiError.Sucesso) {
                    if (response.result.length <= 0) {
                        this.modalService.open(this.novoBeneficio, {
                            centered: true,
                            size: 'lg'
                        });
                    } else {
                        if (!this.exibirFiltro) {
                            this.modalService.open(this.novoColaborador, {
                                centered: true,
                                size: 'lg'
                            });
                        } else {
                            this.RedirectToCreate();
                        }
                    }
                } else {
                    this.alertService.error(response.message);
                }
            });

        this.valorRecargaForm = this.fb.group({
            valorRecarga: new FormControl('', [
                Validators.required
            ])
        });
      }

    createViaArquivo() {
        this.contratoService
            .getContractsAssignorProducts(this.currentUser.token.assignorGuid)
            .subscribe(response => {
                if (response.status === ApiError.Sucesso) {
                    if (response.result.length <= 0) {
                        this.modalService.open(this.novoBeneficio, {
                            centered: true,
                            size: 'lg'
                        });
                    } else {
                        if (!this.exibirFiltro) {
                            this.modalService.open(this.novoColaborador, {
                                centered: true,
                                size: 'lg'
                            });
                        } else {
                            this.RedirectToCreateViaArquivo();
                        }
                    }
                } else {
                    this.alertService.error(response.message);
                }
            });
    }

    RedirectToCreateViaArquivo() {
        this.router.navigate(['create-arquivo'], { relativeTo: this.route.parent });
    }

    RedirectToCreate() {
        this.router.navigate(['create'], { relativeTo: this.route.parent });
    }

    RedirectToCard(collaboratorID: number, collaboratorName: string) {
        sessionStorage.setItem('currentPageB',this.currentPage.toString());
        sessionStorage.setItem('currentCollaborator',collaboratorName);
        this.router.navigate(['cartao/',collaboratorID], { relativeTo: this.route.parent });
        /* this.router.navigate(['beneficios/', collaboratorID], { relativeTo: this.route.parent }); */
    }

    createLote() {
        this.contratoService
            .getContractsAssignorProducts(this.currentUser.token.assignorGuid)
            .subscribe(response => {
                if (response.status === ApiError.Sucesso) {
                    if (response.result.length <= 0) {
                        this.modalService.open(this.novoBeneficio, {
                            centered: true,
                            size: 'lg'
                        });
                    } else {
                        if (!this.exibirFiltro) {
                            this.modalService.open(this.novoColaboradorLote, {
                                centered: true,
                                size: 'lg'
                            });
                        } else {
                            this.RedirectToCreateLote();
                        }
                    }
                } else {
                    this.alertService.error(response.message);
                }
            });
    }

    RedirectToCreateLote() {
        this.router.navigate(['create-lote'], { relativeTo: this.route.parent });
    }

    RedirectToVincularQRLote() {
        this.router.navigate(['vincular-qr-lote'], { relativeTo: this.route.parent });
    }

    edit(collaborator: Collaborator) {
        this.setFilter();
        sessionStorage.setItem('currentCollaborator', JSON.stringify(collaborator));
        this.router.navigate([`edit/${collaborator.collaboratorID}`], {
            relativeTo: this.route.parent
        });
    }

    showFilter(content: any) {
        this.modalService.open(content, { centered: true, size: 'lg' });
    }

    realodList() {
        let tempList = this.collaborators;

        if (this.filtroNome) {
            tempList = tempList.filter(s =>
                s.name.toLowerCase().includes(this.filtroNome.toLowerCase())
            );
        }

        this.collaboratorsList = tempList;
    }

    orderBy(collumnName: string, sortOrder: boolean) {
        this.collumnName=collumnName;
        this.sortOrder=sortOrder;

        this.pageChangedGateway(1);
        /*this.collaboratorsList.sort((a, b) => {
            const dftl = sortOrder ? Number.MAX_VALUE : -Number.MAX_VALUE;
            const aVal = (a[collumnName] === null
                ? dftl
                : a[collumnName]
            ).toString();
            const bVal = (b[collumnName] === null
                ? dftl
                : b[collumnName]
            ).toString();
            let result = aVal.localeCompare(bVal, undefined, { numeric: true });
            if (sortOrder) {
                result = bVal.localeCompare(aVal, undefined, { numeric: true });
            }

            return result;
        });*/
    }

    applyFilter() {
        if(this.nameCtrl.value != null)
            this.filtroNome = this.nameCtrl.value;
        if(this.cpfCtrl.value != null)
            this.filtroCPF = this.cpfCtrl.value.replace(/\./g,'').replace(/\-/g,'').trim();
        if(this.registerCtrl.value != null)
            this.filtroMatricula = this.registerCtrl.value;
        if(this.costCenterCtrl.value != null)
            this.filtroCentroCustoSelectedItems = this.costCenterCtrl.value;
        if(this.unitCtrl.value != null)
            this.filtroUnidadeSelectedItems = this.unitCtrl.value;
        if(this.departmentCtrl.value != null)
            this.filtroDepartamentoSelectedItems = this.departmentCtrl.value;
        if(this.productCtrl.value != null)
            this.filtroProdutosSelectedItems = this.productCtrl.value;
        if(this.typeCtrl.value != null)
            this.filtroType = this.typeCtrl.value;
        if(this.appCtrl.value != null)
            this.filtroAplicativo = this.appCtrl.value;
        if(this.situationCtrl.value != null)
            this.filtroSituacao = this.situationCtrl.value;

        if(
            this.filtroNome == "" &&
            this.filtroCPF == "" &&
            this.filtroCPF == "" &&
            this.filtroMatricula == "" &&
            this.filtroCentroCustoSelectedItems.length == 0 &&
            this.filtroUnidadeSelectedItems.length == 0 &&
            this.filtroDepartamentoSelectedItems.length == 0 &&
            this.filtroProdutosSelectedItems.length == 0 &&
            this.filtroAplicativo == "" &&
            this.filtroSituacao == "" &&
            this.filtroType == 0
        ){
            this.filtroOn = false;
        } else {
            this.filtroOn = true;
        }

        this.pageChangedGateway(1);
    }

    deleteFilter(){
        this.filtroNome = "";
        this.filtroCPF = "";
        this.filtroMatricula = "";
        this.filtroCentroCustoSelectedItems = [];
        this.filtroUnidadeSelectedItems = [];
        this.filtroDepartamentoSelectedItems = [];
        this.filtroProdutosSelectedItems = [];
        this.filtroAplicativo = "";
        this.filtroSituacao = "";
        this.filtroType = 0;
        this.filtroOn = false;

        this.pageChangedGateway(1);
    }

    showDesativar(content: any, collaborator: Collaborator) {
        this.startDateSuspend=null;
        this.endDateSuspend=null;
        this.collaboratorToDisable = collaborator;
        this.modalService.open(content, { centered: true });
    }

    showAtivar(content: any, collaborator: Collaborator) {
        this.collaboratorToEnable = collaborator;
        this.modalService.open(content, { centered: true });
    }

    ShowModalQRCode(content: any, collaborator: Collaborator) {
        this.isValidToAddQRCode = false;
        this.step = 0;
        this.inQRCodeInvalid = false;
        this.inSenhaInvalid = false;
        this.messageSenha = '';
        this.colaboradorToCode = collaborator;
        this.messageStatus = '';
        this.inValorInvalid = false;
        this.messageValor = '';
        this.hasProdutos = true;
        this.hasBeneficios = true;
        this.selectedProduct = null;

        this.cedenteContrato = new CedenteContrato(0,0,'',null,null,null,null,null);
        this.cedenteContrato.valorPadrao = 0;
        this.cedenteContrato.valorMaximoBeneficio = 0;

        // step 0 - escolher produto para vincular cartão

        this.colaboradorService.getBeneficiosFromColaborador(this.currentUser.token.assignorGuid, collaborator.collaboratorID).subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                    this.beneficioGrupo = response.result;

                    if(this.beneficioGrupo.length <= 0){
                        this.hasBeneficios = false;
                        this.hasProdutos = false;
                    }
                } else {
                    this.alertService.error(response.message);
                }
            },
            error => {
                this.alertService.error('Erro ao buscar incentivos');
            }
        );

        this.modalService.open(content, { centered: true, size: 'lg' });
    }


    ShowQRCodeModal(content: any, colaborador: Collaborator) {
        this.colaboradorToCode = colaborador;
        this.messageStatus = '';
        this.usarSenhaExistente = false;

        this.contratoService.ValidaSeTemQRCode(this.currentUser.token.assignorGuid, colaborador.collaboratorID)
        .subscribe(response => {
            if(response.status == ApiError.ColaboradorTemQRCodeNestaCedente)
            {
                this.messageStatus = `O favorecido ${this.colaboradorToCode.name} já recebeu um cartão, para utilizar use o código: ${response.result}`;
            }

            if(response.status == ApiError.ColaboradorTemQRCodeOutraCedente)
            {
                this.associateCardForm.get('confirmPassword').clearValidators();
                this.associateCardForm.get('confirmPassword').updateValueAndValidity();
                this.usarSenhaExistente = true;
            }
        });

        this.modalService.open(content, { centered: true, size: 'lg' });
    }


    private createForm() {
        this.associateCardForm = this.fb.group({
            code: new FormControl('', [
                Validators.required
            ]),
            confirmCode: new FormControl('', [
              Validators.required
            ]),
            password: new FormControl('', [
                Validators.required
            ]),
            confirmPassword: new FormControl('', [
              Validators.required
            ])
        });

        this.valorRecargaForm = this.fb.group({
            valorRecarga: new FormControl('', [
                Validators.required
            ])
        });
      }


    ShowModalCarregarCartao(content: any, colaborador: Collaborator) {

        this.colaboradorToCode = colaborador;
        this.messageStatus = '';
        this.usarSenhaExistente = false;
        this.continuarRecarga = false;
        this.hasProdutos = true;
        this.hasBeneficios = true;
        this.selectedProduct = null;
        this.inValorInvalid = false;
        this.valorRecargaForm.controls.valorRecarga.setValue(null);

        if(colaborador.hasCard){
            this.contratoService.ValidaSeTemQRCode(this.currentUser.token.assignorGuid, colaborador.collaboratorID)
            .subscribe(response => {
                if (response.status == ApiError.ColaboradorTemQRCodeNestaCedente) {
                    this.qrcodeValue = response.result;
                    this.modalService.open(content, { centered: true, size: 'lg' });
                }
            });
        }else{
            this.modalService.open(content, { centered: true, size: 'lg' });
        }

        this.currentUser = this.authenticationService.currentUserValue;

        this.colaboradorService.getBeneficiosFromColaborador(this.currentUser.token.assignorGuid, colaborador.collaboratorID).subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                    this.beneficioGrupo = response.result;
                    //this.beneficioGrupo = this.beneficioGrupo.filter(el => el.podeListar && el.produtoCategoriaId != CategoriaProduto.Flex);
                    this.beneficioGrupo.sort((a, b) => (a.orderListagemCategoria > b.orderListagemCategoria) ? 1 : -1);
                    if(this.beneficioGrupo.length <= 0){
                        this.hasBeneficios = false
                    }
                } else {
                    this.alertService.error(response.message);
                }
            },
            error => {
                this.alertService.error('Erro ao buscar incentivos');
            }
        );
    }

    NextStep(qrcode: string, valor: number) {
        this.valorBeneficio = Math.round(valor);

        if(this.step == 10){
            if (!qrcode) {
                this.inQRCodeInvalid = true;
            } else if (valor < this.cedenteContrato.valorPadrao) {
                this.inValorInvalid = true;
                this.messageValor =
                    'O valor mínimo do incentivo deve ser de R$' +
                    this.cedenteContrato.valorPadrao;
            } else if (valor > this.cedenteContrato.valorMaximoBeneficio
                        && (this.cedenteContrato.valorMaximoBeneficio != 0)) {
                this.inValorInvalid = true;
                this.messageValor =
                    'O valor maximo do incentivo deve ser de R$' +
                    this.cedenteContrato.valorMaximoBeneficio;
            } else {
                this.step = 20;
            }
        }
    }

    ShowModalAlterarSenha(content: any, collaborator: Collaborator) {
        this.inSenhaInvalid = false;
        this.messageSenha = '';
        this.step = 0;

        this.colaboradorToAlterPass = collaborator;
        this.modalService.open(content, { centered: true, size: 'lg', windowClass: 'modal-senha' });
    }

    AlterarSenha(senha: string, senhaConfirmacao: string) {
        if (!senha || !senhaConfirmacao) {
            this.messageSenha = 'Campos de senha obrigatórios';
            this.inSenhaInvalid = true;
            return;
        }

        if (senha.length < 6 || senha.length > 6) {
            this.messageSenha = 'A senha deve ter 6 dígitos';
            this.inSenhaInvalid = true;
            return;
        }

        if (senha === senhaConfirmacao) {
            const associarQRCodeRequest = new AssociarQRCodeRequest();
            associarQRCodeRequest.Senha = senha;
            associarQRCodeRequest.SenhaConfirmacao = senhaConfirmacao;
            associarQRCodeRequest.cedenteGuid = this.currentUser.token.assignorGuid;
            associarQRCodeRequest.colaboradorID = this.colaboradorToAlterPass.collaboratorID;

            this.securityService
                .ResetSenhaColaborador(associarQRCodeRequest)
                .subscribe(
                    response => {
                        if (response.status === ApiError.Sucesso) {
                            this.alertService.success('Senha alterada com sucesso');
                            this.modalService.dismissAll();
                        } else {
                            this.alertService.warning(response.message);
                        }
                    },
                    error => {
                        this.alertService.error('Não foi possível alterar a senha');
                    }
                );
        } else {
            this.messageSenha = 'As senhas devem ser iguais';
            this.inSenhaInvalid = true;
        }
    }

    Cadastrar(
        qrcode: string,
        senha: string,
        senhaConfirmacao: string,
        valor: number,
        taxa: number = 0,
        ehPorcentagem: boolean,
    ) {
        if (!senha || !senhaConfirmacao) {
            this.messageSenha = 'Campos de senha obrigatórios';
            this.inSenhaInvalid = true;
            return;
        }

        if (senha.length < 6 || senha.length > 6) {
            this.messageSenha = 'A senha deve ter 6 dígitos';
            this.inSenhaInvalid = true;
            return;
        }

        if (senha === senhaConfirmacao) {
            valor = parseFloat(valor.toString());
            let valorTaxa = 0;
            if(taxa > 0){
                if(ehPorcentagem){
                    valorTaxa = valor * taxa / 100;
                    valor += valor * taxa / 100;
                }else{
                    valorTaxa = taxa;
                    valor = valor + taxa;
                }
            }

            const associateCardModel = new AssociateCardModel();
            associateCardModel.password = senha;
            associateCardModel.confirmPassword = senhaConfirmacao;
            associateCardModel.code = qrcode.trim();
            associateCardModel.confirmCode = qrcode.trim();
            associateCardModel.assignorGuid = this.currentUser.token.assignorGuid;
            associateCardModel.colaboratorID = this.colaboradorToCode.collaboratorID;
            associateCardModel.managerGuid = this.currentUser.token.userReferenceId;
            //associateCardModel.valor = valor;

            this.messageStepOk = false;
            this.messageStep = '';

            const purchase = new FastPurchase(
                (Math.round(valor * 1000) / 1000), taxa, valorTaxa, this.selectedProduct.produtoId, this.selectedProduct.cedenteContratoId,
                this.selectedProduct.periodoValor, this.selectedProduct.valor, this.selectedProduct.produtoGuid,
                this.selectedProduct.produtoNome, this.selectedProduct.periodo, ehPorcentagem,
                this.selectedProduct.cartaoId
            );

            this.contratoService
                .cardToColaborator(associateCardModel)
                .subscribe(
                    async response => {
                        this.step = 30;
                        if (response.status === 1) {
                            this.createPurchase(purchase)
                            this.messageStepOk = true
                            this.filtroPesquisa = this.colaboradorToCode.document;
                            this.pageChangedGateway(1);
                        } else {
                            this.messageStepOk = false;
                            this.messageStep = response.message;
                        }
                    },
                    error => {
                        this.step = 30;
                        this.messageStepOk = false;
                        this.messageStep = `Desculpe ${this.colaboradorToCode.name} tivemos um problema ao realizar o cadastro, tente novamente.`;
                    }
                );
        } else {
            this.messageSenha = 'Digite senhas iguais';
            this.inSenhaInvalid = true;
        }
    }

    enable(collaborator: Collaborator, inObservacao: string = null) {
        if(inObservacao != null && inObservacao != ""){
            inObservacao = inObservacao.replace(/[\\"]/g, "'");
            inObservacao = '"' + inObservacao + '"';
            this.modalService.dismissAll();
            this.colaboradorService
            .enable(
                collaborator.collaboratorID,
                this.currentUser.token.assignorGuid,
                this.currentUser.token.userReferenceId,
                inObservacao
            )
            .subscribe(
                response => {
                    this.alertService.success(response.message);
                    this.pageChangedGateway(1);
                    this.realodList();
                },
                error =>
                    this.alertService.error(
                        'Ocorreu um erro ao desativar o favorecido'
                    )
            );
        } else {
            this.justificativaValid = false;
        }
    }

    disable(collaborator: Collaborator, inObservacao: string = null) {
        if(inObservacao != null && inObservacao != ""){
            inObservacao = inObservacao.replace(/[\\"]/g, "'");
            inObservacao = '"' + inObservacao + '"';
            this.modalService.dismissAll();
            this.colaboradorService
            .disable(
                collaborator.collaboratorID,
                this.currentUser.token.assignorGuid,
                this.currentUser.token.userReferenceId,
                inObservacao
            )
            .subscribe(
                response => {
                    this.alertService.success(response.message);
                    this.pageChangedGateway(1);
                    this.realodList();
                },
                error =>
                    this.alertService.error(
                        'Ocorreu um erro ao desativar o favorecido'
                    )
            );
        } else {
            this.justificativaValid = false;
        }
    }

    suspend(collaborator: Collaborator, inObservacao: string = null) {

        inObservacao = this.justifySuspend.value;
        this.justifySuspend.setValue(null);

        if(inObservacao != null && inObservacao != "" && this.startDateSuspend != null && this.startDateSuspend != null){

            const suspendObject = new SuspendColllaboratorRequestModel();

            suspendObject.ManagerGuid = this.currentUser.token.userReferenceId;
            suspendObject.AssignorGuid = this.currentUser.token.assignorGuid;
            suspendObject.CollaboratorId = collaborator.collaboratorID;
            suspendObject.StartDateSuspension = this.startDateSuspend;
            suspendObject.EndDateSuspension = this.endDateSuspend;
            suspendObject.Reason = inObservacao

            this.modalService.dismissAll();
            this.colaboradorService
            .suspend(
                suspendObject
            )
            .subscribe(
                response => {
                    this.alertService.success(response.message);
                    this.pageChangedGateway(1);
                    this.realodList();
                },
                error =>
                    this.alertService.error(
                        'Ocorreu um erro ao desativar o favorecido'
                    )
            );
        } else {
            this.justificativaValid = false;
        }
    }

    updateDeleteCount() {
        this.deleteCount = this.collaboratorsList.filter(
            x => x.toDelete
        ).length;
    }

    selectAllToDelete(value: boolean) {
        this.collaboratorsList.forEach(obj => {
            obj.toDelete = value;
        });
        this.updateDeleteCount();
    }

    showDeleteAll(content: any) {
        this.updateDeleteCount();
        this.modalService.open(content, { centered: true, size: 'sm' });
    }

    deleteAllSelected() {
        this.collaboratorsList.forEach(obj => {
            if (obj.toDelete) {
                this.disable(obj);
            }
        });
        this.updateDeleteCount();
    }

    vincularQrCode() {

        if (this.associateCardForm.valid) {
            let associateCardModel = new AssociateCardModel(this.associateCardForm.value);

            if (associateCardModel.code == null || associateCardModel.code == ''
            || associateCardModel.confirmCode == null || associateCardModel.confirmCode == '') {
                this.messageCodigo = 'Código obrigatório';
                this.inCodigoInvalid = true;
                return;
            }

            else if (associateCardModel.code != associateCardModel.confirmCode) {
                this.messageCodigo = 'Os códigos devem ser iguais';
                this.inCodigoInvalid = true;
                return;
            }

            if (associateCardModel.password.length < 6 || associateCardModel.password.length > 6) {
                this.messageCodigo = null;
                this.inCodigoInvalid = false;
                this.messageSenha = 'A senha deve ter 6 dígitos';
                this.inSenhaInvalid = true;
                return;
            }

            else if(associateCardModel.password != associateCardModel.confirmPassword){
                this.messageSenha = 'As senhas devem ser iguais';
                this.inSenhaInvalid = true;
                return;
            }

            associateCardModel.code = associateCardModel.code.trim();
            associateCardModel.confirmCode = associateCardModel.confirmCode.trim();
            associateCardModel.assignorGuid = this.currentUser.token.assignorGuid;
            associateCardModel.colaboratorID =  this.colaboradorToCode.collaboratorID;
            associateCardModel.managerGuid = this.currentUser.token.userReferenceId;
            associateCardModel.existsUser = this.usarSenhaExistente;

            this.contratoService
                .cardToColaborator(associateCardModel)
                .subscribe(
                    response => {
                        if(response.status == ApiError.Sucesso){
                            this.alertService.success('Cartão associado com sucesso');
                            this.modalService.dismissAll();
                            this.associateCardForm.reset();
                            this.pageChangedGateway(this.currentPage);
                        }else{
                            this.alertService.error(response.message);
                        }
                    },
                    error => {
                       this.alertService.error('Erro ao associar o cartão');
                       this.modalService.dismissAll();
                       this.associateCardForm.reset();
                    }
                );
        }
    }

    //#region DropDown methods
    public loadFiltroDropDown() {
        this.centroCustoService
            .getAll(this.currentUser.token.assignorGuid)
            .subscribe(response => {
                this.centrosCustosList = response.result;
                this.centrosCustosList.forEach(obj => {
                    this.filtroCentroCustoDropDownList.push(
                        new DropDownItem(obj.centroCustoId.toString(), obj.nome)
                    );
                });
            });

        this.unidadeService
            .getAll(this.currentUser.token.assignorGuid)
            .subscribe(response => {
                this.unidadesList = response.result;
                this.unidadesList.forEach(obj => {
                    this.filtroUnidadeDropDownList.push(
                        new DropDownItem(obj.unidadeId.toString(), obj.nome)
                    );
                });
            });

        this.departamentoService
            .getAll(this.currentUser.token.assignorGuid)
            .subscribe(response => {
                this.departamentosList = response.result;
                this.departamentosList.forEach(obj => {
                    this.filtroDepartamentoDropDownList.push(
                        new DropDownItem(
                            obj.departamentoId.toString(),
                            obj.nome
                        )
                    );
                });
            });

        this.contratoService
            .getContractsAssignorProducts(this.currentUser.token.assignorGuid)
            .subscribe(response => {
                response.result.forEach(obj => {
                    this.filtroProdutosDropDownList.push(
                        new DropDownItem(
                            obj.produtoGuid.toString(),
                            obj.descricaoProduto
                        )
                    );
                });
            });

        this.dropDownSettings = {
            singleSelection: false,
            idField: 'ITEM_ID',
            textField: 'ITEM_TEXT',
            selectAllText: 'Selecionar Tudo',
            unSelectAllText: 'Desmarcar Tudo',
            searchPlaceholderText: 'Buscar',
            allowSearchFilter: true,
            itemsShowLimit: 3
        };
    }

    onItemSelectFiltroCentroCusto(item: any) { }
    onSelectAllFiltroCentroCusto(items: any) { }
    onItemDeSelectFiltroCentroCusto(items: any) { }

    onItemSelectFiltroUnidade(item: any) { }
    onSelectAllFiltroUnidade(items: any) { }
    onItemDeSelectFiltroUnidade(items: any) { }

    onItemSelectFiltroDepartamento(item: any) { }
    onSelectAllFiltroDepartamento(items: any) { }
    onItemDeSelectFiltroDepartamento(items: any) { }

    onItemSelectFiltroProdutos(item: any) { }
    onSelectAllFiltroProdutos(items: any) { }
    onItemDeSelectFiltroProdutos(items: any) { }
    //#endregion

    //#region qr-code

    clearResult(): void {
        this.qrResultString = null;
    }

    onCamerasFound(devices: MediaDeviceInfo[]): void {
        this.availableDevices = devices;
        this.hasDevices = Boolean(devices && devices.length);
    }

    onCodeResult(resultString: string) {
        this.qrResultString = resultString;
        this.qrCodeDetected = true;
        this.qrCodeDetectedVisivle = true;

        setTimeout(() => (this.qrCodeDetectedVisivle = false), 3000);
    }

    onDeviceSelectChange(selected: string) {
        const device = this.availableDevices.find(x => x.deviceId === selected);
        this.currentDevice = device || null;
    }

    openFormatsDialog() {
        const data = {
            formatsEnabled: this.formatsEnabled
        };
    }

    onHasPermission(has: boolean) {
        this.hasPermission = has;
    }

    openInfoDialog() {
        const data = {
            hasDevices: this.hasDevices,
            hasPermission: this.hasPermission
        };
    }

    toggleTryHarder(): void {
        this.tryHarder = !this.tryHarder;
    }
    //#endregion

    getFilter() {
        const filter = this.filterService.getFilterValue();
        if (filter) {
            this.filtroCodigo = filter.filtroCodigo;
            this.filtroNome = filter.filtroNome;
            this.filtroCPF = filter.filtroCPF;
            this.filtroAplicativo = filter.filtroAplicativo;
            this.filtroSituacao = filter.filtroSituacao;
            this.filtroCentroCustoSelectedItems = filter.filtroCentroCustoSelectedItems;
            this.filtroUnidadeSelectedItems = filter.filtroUnidadeSelectedItems;
            this.filtroDepartamentoSelectedItems = filter.filtroDepartamentoSelectedItems;
            this.filtroProdutosSelectedItems = filter.filtroProdutosSelectedItems;
            this.filterService.clear();
        }
    }

    setFilter() {
        const filter = new FiltroColaborador(this.filtroCodigo, this.filtroNome,
            this.filtroCPF, this.filtroMatricula,
            this.filtroAplicativo, this.filtroSituacao,this.filtroPesquisa,
            this.filtroCentroCustoSelectedItems,
            this.filtroUnidadeSelectedItems,
            this.filtroDepartamentoSelectedItems,
            this.filtroProdutosSelectedItems);

        this.filterService.setFilterValue(filter);
    }

    ShowModalBenefits(content: any, colaborador: Collaborator) {
        this.CollaboratorDetailsModel = null;
        this.messageStatus = '';

        if (!colaborador.personGuid || colaborador.personGuid == '00000000-0000-0000-0000-000000000000' ) {
            this.alertService.error(
                'Favorecido não possui saldo'
            );
            return;
        }

        this.colaboradorService
            .GetDetails(colaborador.personGuid, this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId)
            .subscribe(
                result => {
                    if (result.status === 1) {
                        this.CollaboratorDetailsModel = result.result;
                        this.showBenefits = true;
                    } else {
                        this.showBenefits = false;
                        this.messageStatus = result.message;
                    }

                    this.modalService.open(content, {
                        centered: true,
                        size: 'lg'
                    });
                },
                error => {
                    this.alertService.error(
                        'Usuário sem acesso ao app ou cartão'
                    );
                }
            );
    }

    VincularCartao(item: Collaborator){
        sessionStorage.setItem('currentPageB',this.currentPage.toString());
        sessionStorage.setItem('currentCollaborator', JSON.stringify(item));
        if(item.collaboratorCardId == null && !item.collaboratorCardDefinitiveBlock)
            this.router.navigate( [`vincular-cartao`],{ relativeTo: this.route.parent });
        else{
            this.ShowModalAvisoCartao(item);
        }
    }

    VincularCartaoPortador(item: Collaborator){
        sessionStorage.setItem('currentPageB',this.currentPage.toString());
        sessionStorage.setItem('currentCollaborator', JSON.stringify(item));
        if(item.cardholderGuid !== null)
            this.router.navigate( [`vincular-cartao-portador/${item.cardholderGuid}`],{ relativeTo: this.route.parent });
    }

    redirectVincularCartao(){
        this.router.navigate( [`vincular-cartao`],{ relativeTo: this.route.parent });
    }

    ShowModalAvisoCartao(item: Collaborator){
        //let content = modalAvisoVincularCartao;
        this.collaboratorSelected = item;
        this.modalService.open(this.modalAvisoVincularCartao, {
            centered: true,
            size: 'lg'
        });
    }

    ShowModalVerCartao(content: any, item: Collaborator){
        this.collaboratorSelected = item;
        this.modalService.open(content, {
            centered: true,
            size: 'lg'
        });
    }

    ShowModalNovoSMS(content: any, item: Collaborator){
        this.collaboratorSelected = item;
        this.modalService.open(content, {
            centered: true,
            size: 'lg'
        });
    }

    ShowModalTrocarSenhaCartao(content: any, item: Collaborator){
        this.collaboratorSelected = item;

        this.modalService.open(content, {
            centered: true,
            size: 'lg'
        });
    }

    ShowModalTrocarSenhaCartaoPortador(content: any, item: Collaborator){
        this.collaboratorSelected = item;

        this.cardPasswordResetFormGroup = this.fb.group({
            newCardPin: new FormControl(null, [
                Validators.required,
                Validators.minLength(4),
                Validators.maxLength(4)
            ]),
            confirmNewCardPin: new FormControl(null, [
                Validators.required,
                GenericValidator.mustMatch('newCardPin')
            ])
        });

        this.modalService.open(content, {
            centered: true,
            size: 'lg'
        });
    }

    ShowModalConfimacao(content: any, item: boolean){
        this.temp = item;
        this.modalService.open(content, {
            centered: true,
            size: 'md'
        });
    }

    showResetarSenhaCondutor(content: any, item: string){
        this.temp = item;
        this.modalService.open(content, {
            centered: true,
            size: 'md'
        });
    }

    resetarSenhaCondutor(){
        this.conductorService.changeConductorPassword(this.temp.toString()).subscribe(
            result => {
                if(result.status == ApiError.Sucesso){
                    this.modalService.dismissAll();
                    this.alertService.success("Senha atualizada e enviada via sms para o condutor!");
                }
                else{
                    this.modalService.dismissAll();
                    this.alertService.error(result.message);
                }
            },
            error => {console.error(error);
            }
        )
    }

    enviarNovoSMS(id: number){
        //enviar novo sms - api cartoes?
    }

    trocarSenhaCartao(){
        //requisitar pedido troca de cartão - api cartoes?
        let updateRequest = new UpdateRequest();
        updateRequest.psCardId = this.collaboratorSelected.collaboratorCardId;
        updateRequest.managerGuid = this.currentUser.token.userReferenceId;
        this.physicalCardService.changeCardPassword(updateRequest).subscribe(
            result => {
                if(result.status == ApiError.Sucesso){
                    this.modalService.dismissAll();
                    this.alertService.success("Troca de senha realizada com sucesso!");
                }
                else{
                    this.modalService.dismissAll();
                    this.alertService.error(result.message);
                }
            },
            error => {console.error(error);
            }
        )
    }

    trocarSenhaCartaoPortador(){
        //requisitar pedido troca de cartão - api cartoes?
        let updateRequest = new UpdateRequest();
        updateRequest.psCardId = this.collaboratorSelected.cardholderCardId;
        updateRequest.managerGuid = this.currentUser.token.userReferenceId;
        updateRequest.newCardPin = this.cardPasswordResetFormGroup.get('newCardPin').value;
        updateRequest.confirmNewCardPin = this.cardPasswordResetFormGroup.get('confirmNewCardPin').value;

        this.physicalCardService.changeCardPasswordLegalPerson(updateRequest).subscribe(
            result => {
                if(result.status == ApiError.Sucesso){
                    this.modalService.dismissAll();
                    this.alertService.success("Troca de senha realizada com sucesso!");
                }
                else{
                    this.modalService.dismissAll();
                    this.alertService.error(result.message);
                }
            },
            error => {console.error(error);
            }
        )
    }

    bloquearCartao(temporary: boolean = false, redirect: boolean = false){
        let index = this.collaborators.findIndex((obj => obj.collaboratorID == this.collaboratorSelected.collaboratorID));

        let blockRequest = new BlockRequest();
        blockRequest.psCardId = this.collaboratorSelected.collaboratorCardId;
        blockRequest.managerGuid = this.currentUser.token.userReferenceId;

        if(!temporary){
            this.physicalCardService.blockDefinitive(blockRequest, 35).subscribe(
                result => {
                    if(result.status == ApiError.Sucesso){
                        this.modalService.dismissAll();
                        this.alertService.success("Cartão bloqueado com sucesso!"); }
                        this.collaborators[index].collaboratorCardDefinitiveBlock = true;
                        if(redirect)
                            this.redirectVincularCartao();
                    else{
                        this.modalService.dismissAll();
                        this.alertService.error(result.message);
                    }
                }
            )
        }

        if(temporary){
            this.physicalCardService.blockTemporary(blockRequest).subscribe(
                result => {
                    if(result.status == ApiError.Sucesso){
                        this.modalService.dismissAll();
                        this.alertService.success("Cartão bloqueado temporariamente com sucesso!");
                        this.collaborators[index].collaboratorCardTemporaryBlock = true;
                    }
                    else{
                        this.modalService.dismissAll();
                        this.alertService.error(result.message);
                    }
                }
            )
        }
    }



    desbloquearCartao(otherReason: string){
        let index = this.collaborators.findIndex((obj => obj.collaboratorID == this.collaboratorSelected.collaboratorID));

        let blockRequest = new BlockRequest();
        blockRequest.psCardId = this.collaboratorSelected.collaboratorCardId;
        blockRequest.managerGuid = this.currentUser.token.userReferenceId;

        this.physicalCardService.unblockTemporary(blockRequest).subscribe(
            result => {
                if(result.status == ApiError.Sucesso){
                    this.modalService.dismissAll();
                    this.alertService.success("Cartão desbloqueado com sucesso!");
                    this.collaborators[index].collaboratorCardTemporaryBlock = false;
                }
                else{
                    this.modalService.dismissAll();
                    this.alertService.error(result.message);
                }
            }
        )
    }



    /*ShowModalBenefits(content: any, colaborador: Colaborador) {
        this.CollaboratorDetailsModel = null;
        this.messageStatus = '';
        if (!colaborador.pessoaGuid) {
            this.alertService.error(
                'Favorecido não possui aplicativo instalado'
            );
            return;
        }
        this.colaboradorService
            .GetDetails(colaborador.pessoaGuid, colaborador.cedenteGuid, this.currentUser.token.userReferenceId)
            .subscribe(
                result => {
                    if (result.status === 1) {
                        this.CollaboratorDetailsModel = result.result;
                        this.showBenefits = true;
                    } else {
                        this.showBenefits = false;
                        this.messageStatus = result.message;
                    }

                    this.modalService.open(content, {
                        centered: true,
                        size: 'lg'
                    });
                },
                error => {
                    this.alertService.error(
                        'Ocorreu um erro ao buscar os detalhes do favorecido'
                    );
                }
            );
    }*/

    NavigateToResgateBeneficio(colaborador: Collaborator) {
        this.router.navigate(
            [`../gestao-beneficio/resgate/${colaborador.collaboratorID}`],
            { relativeTo: this.route.parent }
        );
    }

    NavigateToTransfereBeneficio(colaborador: Collaborator) {
        this.router.navigate(
            [`../gestao-beneficio/transfere-beneficio/${colaborador.collaboratorID}`],
            { relativeTo: this.route.parent }
        );
    }

    capitalize(word: string){
        const lower = word.toLowerCase();
        return word.charAt(0).toUpperCase() + lower.slice(1);
    }

    copyCode(val: string){
        val = val.toUpperCase()
        let selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = val;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
        this.alertService.success('Código QR ('+val+') copiado');
    }

    setPeriod(inicio,date: Date){
        if(inicio){
            this.extratoDataInicio = date;
        } else if(this.extratoDataInicio == null || this.extratoDataInicio >= date) {
            this.extratoDataFim = this.extratoDataInicio;
            this.extratoDataInicio = date;
        } else {
            this.extratoDataFim = date;
        }
    }

    setPeriodSuspend(inicio,date: Date){
        if(inicio){
            this.startDateSuspend = date;
        } else if(this.startDateSuspend == null || this.startDateSuspend >= date) {
            this.endDateSuspend = this.startDateSuspend;
            this.startDateSuspend = date;
        } else {
            this.endDateSuspend = date;
        }
    }

    lastCredits(colaId, content){
        this.colaId = colaId;
        let date = new Date();
        this.extratoDataFim = date;
        this.extratoDataInicio = new Date();
        this.extratoDataInicio.setDate(this.extratoDataInicio.getDate()-90);

        this.getExtract(1,this.colaId);
        this.modalService.open(content, { centered: true, size: 'xl' });
    }

    getExtract(event, colaId){
        this.extractList = [];
        this.extractPage = event;
        const offset = this.extractPage - 1;

        const filterObject = new ExtractRequest();

        if(this.extratoDataInicio == null || this.extratoDataFim == null){
            this.alertService.error("Selecione um periode de datas");
            return
        }

        filterObject.assignorGuid = this.currentUser.token.assignorGuid;
        filterObject.limit = this.limitModal;
        filterObject.offset = offset;
        filterObject.startDate = this.extratoDataInicio;
        filterObject.endDate = this.extratoDataFim;
        filterObject.datePeriod = this.extratoPeriodo;
        filterObject.details = true;
        filterObject.products = this.extratoProduto;
        filterObject.collaborators = [colaId.collaboratorID];
        filterObject.status = null;

        this.alertService.clear();
        this.extractService
            .getExtract(
                filterObject
            )
            .subscribe(
                response => {
                    if (response.status === ApiError.Sucesso) {
                        this.extractDetails = response.result.details;
                        this.extractList = response.result.extract;
                        this.extracttotalItems = this.extractDetails.totalItems;

                        for (const s of this.extractList) {;
                            if(s.collaboratorDocument != null){
                                const tam = environment.TOTAL_CARACTERE_CPF - s.collaboratorDocument.toString().length;
                                let str = s.collaboratorDocument.toString();

                                for (let i = 0; i < tam; i++) {
                                    str = '0' + str;
                                }

                                s.collaboratorDocument = str;
                            }
                        }
                    } else {
                        this.alertService.error(response.message);
                    }
                },
                error => {
                    this.alertService.error(
                        'Ocorreu um erro ao paginar o extrato'
                    );
                }
            );
    }

    showModalExtractFavored(content, colaId){
        this.extractList = [];
        this.colaId = colaId;
        let date = new Date();
        this.extratoDataFim = date;
        this.extratoDataInicio = new Date();
        this.extratoDataInicio.setDate(this.extratoDataInicio.getDate()-89);
        this.colaboradorService.getContasColaborador(this.currentUser.token.assignorGuid, colaId.collaboratorID).subscribe(
            res => {
                if (res.status === ApiError.Sucesso) {
                    this.accounts = res.result;
                    this.getExtractFavored(1);
                } else {
                    this.alertService.error(res.message);
                }
            },
        );
        this.modalService.open(content, { centered: true, size: 'xl' });
    }

    getExtractFavored(event){
        this.extractPage = event;
        const offset = (this.extractPage - 1)*this.limitModal;

        this.filterObject.accountArray = this.accounts.accountsGuid;
        this.filterObject.accountGuid = null;
        this.filterObject.details = true;
        this.filterObject.initialDate = this.extratoDataInicio;
        this.filterObject.finalDate = this.extratoDataFim;
        this.filterObject.launchType = 0;
        this.filterObject.limit = this.limitModal;
        this.filterObject.offset = offset;
        this.filterObject.personGuid = this.accounts.personGuid;
        this.filterObject.rangeDays = 1;
        this.filterObject.tip = null;

        this.alertService.clear();
        this.extractFavored(this.filterObject).subscribe(
            res => {
                if (res.status === ApiError.Sucesso) {
                    this.extractDetails = res.result.detailsExtract;
                    this.extractList = res.result.detailsTransactions;
                    this.extracttotalItems = this.extractDetails.totalRegistros;
                } else {
                    this.alertService.error(res.message);
                }
            },
            error => {
                this.alertService.error(
                    'Ocorreu um erro ao paginar o extrato'
                );
            }
        );
    }

    extractFavored(filterObject){
        return this.extractService.getExtractConsumer(filterObject)
    }

    exportExtractExcel(){
        this.filterObject.limit = this.extracttotalItems;
        this.filterObject.offset = 0;
        let result = [];
        let date: any = new Date();
        date = date.toLocaleDateString('pt-BR');
        date = date.split('/');

        const excelService = new ExcelService();
        const worksheets = new Array<WorksheetData>();
        const ws = new WorksheetData();
        ws.worksheetTitle = 'Extrato_' + this.colaId.document + '_' + date[2] + date[1] + date[0];
        ws.worksheetHeaders = ['Pessoa Transação', 'Descritivo Transação', 'Produto', 'Data da Transação', 'Valor', 'Via'];
        ws.WorksheetRows = [];

        this.extractFavored(this.filterObject).subscribe(
            res => {
                if (res.status === ApiError.Sucesso) {
                    result = res.result.detailsTransactions;
                    result.forEach((r) => {
                        const lr = new Array<string>();
                        lr.push(r.pessoaTransacao);
                        lr.push(r.descritivoTransacao);
                        lr.push(r.descricaoProduto);
                        lr.push(this.datepipe.transform(r.dataTransacao, 'dd/MM/yyyy HH:mm'));
                        lr.push(r.valorLiquido.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }));
                        lr.push(r.tipoTransacao==1 ? 'SeuVale' : r.tipoTransacao==2 ? 'Pix' : r.tipoTransacao==3 ? 'Cartão' : '');
                        ws.WorksheetRows.push(lr);
                    });

                    worksheets.push(ws);

                    /*excelService.generateExcel('Extrato Portal Cedente', worksheets).csv
                    .writeBuffer({ encoding: 'UTF-8', formatterOptions: { delimiter: ';' } }).then((data) => {
                        const blob = new Blob(['\ufeff', data], { type: 'text/csv; charset=UTF-8,'  });
                        saveAs(blob, ws.worksheetTitle + '.csv');
                    });*/

                    excelService.generateExcelReport('Extrato: ' + this.colaId.name, worksheets,null).xlsx
                    .writeBuffer().then((data) => {
                        const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        saveAs(blob, ws.worksheetTitle + '.xlsx');
                    });

                } else {
                    this.alertService.error(res.message);
                }
            },
            error => {
                this.alertService.error(
                    'Ocorreu um erro ao paginar o extrato'
                );
            }
        );
    }

    exportExtractPdf(){
        this.filterObject.limit = this.extracttotalItems;
        this.filterObject.offset = 0;
        let result = [];
        let date: any = new Date();
        date = date.toLocaleDateString('pt-BR');
        date = date.split('/');

        const pdfData = new PdfData();
        pdfData.PdfTitle = 'Extrato_' + this.colaId.document + '_' + date[2] + date[1] + date[0];
        pdfData.PdfHeaders = ['Pessoa Transação', 'Descritivo Transação', 'Produto', 'Data da Transação', 'Valor', 'Via'];
        pdfData.PdfRows = [];

        this.extractFavored(this.filterObject).subscribe(
            res => {
                if (res.status === ApiError.Sucesso) {
                    result = res.result.detailsTransactions;
                    result.forEach((r) => {
                        const lr = new Array<string>();
                        lr.push(r.pessoaTransacao);
                        lr.push(r.descritivoTransacao);
                        lr.push(r.descricaoProduto);
                        lr.push(this.datepipe.transform(r.dataTransacao, 'dd/MM/yyyy HH:mm'));
                        lr.push(r.valorLiquido.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }));
                        lr.push(r.tipoTransacao==1 ? 'SeuVale' : r.tipoTransacao==2 ? 'Pix' : r.tipoTransacao==3 ? 'Cartão' : '');
                        pdfData.PdfRows.push(lr);
                    });


                    const pdfService = new PdfService();
                    pdfService.generatePdfReport('Extrato: ' + this.colaId.name, pdfData,null,null,true).getBlob((blob) => {
                      saveAs(blob, pdfData.PdfTitle + '.pdf');
                    });
                } else {
                    this.alertService.error(res.message);
                }
            },
            error => {
                this.alertService.error(
                    'Ocorreu um erro ao paginar o extrato'
                );
            }
        );
    }

    solicitarPin(){
        if(!this.isResposavel && this.validarPin){
            this.gestorService.solicitarPin(this.currentUser.token.assignorGuid,this.currentUser.token.userReferenceId).subscribe(
                res => {
                    if (res.status === ApiError.Sucesso) {
                    } else {
                        this.alertService.error(res.message);
                    }
                }
            );
        }
    }

    getReason(data) {
        if (data == 'otherReason') {
            this.reason = data;
            this.showOtherReasonInp = true;
        } else {
            this.reason = data;
            this.showOtherReasonInp = false;
        }
      }

    showReason(checked: boolean){
        this.showReasons = checked;
    }
}
